import styled, { css } from 'styled-components';
import { widthMap } from '@components/ui/Modal/ModalStyles';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(${widthMap.xs} - ${theme.spacing.km12});
    min-height: 230px;

    > div {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.km2};
    }

    fuel-loading {
      color: ${theme.color.icon.brand.default};
    }
  `}
`;
